import type { IconProps } from '../types/IconProps.ts';
export const GlobeLock: IconProps = {
    name: 'GlobeLock',
    children: [
        `<path d="M21.8 14A10 10 0 1 1 11 2.05M2 12h8" />`,
        `<path d="M11 2.31C9.27 3.43 8 7.34 8 12c0 5.52 1.8 10 4 10 1.64 0 3.38-3.47 4-7" />`,
        `<rect width="8" height="5" x="13" y="6" rx="1" />`,
        `<path d="M15 5V4a2 2 0 1 1 4 0v1" />`,
    ]
};